import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer,
  Typography } from '@material-ui/core';

// import DashboardIcon from '@material-ui/icons/Dashboard';
// import PeopleIcon from '@material-ui/icons/People';
// import NotificationsIcon from '@material-ui/icons/Notifications';

// import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
// import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
// import TextFieldsIcon from '@material-ui/icons/TextFields';
// import ImageIcon from '@material-ui/icons/Image';
// import AccountBoxIcon from '@material-ui/icons/AccountBox';
// import SettingsIcon from '@material-ui/icons/Settings';
// import LockOpenIcon from '@material-ui/icons/LockOpen';
// import Compare from '@material-ui/icons/Compare';
// import EvStationIcon from '@material-ui/icons/EvStation';
// import PowerIcon from '@material-ui/icons/Power';
// import AddIcCallIcon from '@material-ui/icons/AddIcCall';
// import AddCircleIcon from '@material-ui/icons/AddCircle';

import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Profile, SidebarNav } from './components';
import { useMediaQuery } from 'react-responsive';
import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';


const Sidebar = props => {
  const { open, variant, onClose, className, router, tempSetUser, simuSettings, ...rest } = props;

  const classes = useStyles();

  var accountPage = '';

  const selector_chgr_cnt = useSelector((state) => state.simuSettings.chgr_cnt);


  // const userjson = localStorage.getItem('userinfo');
  // if(!userjson) {
  //   console.log('user storage 없음');

  //   setTimeout( () => {
  //     // history.go('/sign-in');
  //     window.location.href = '/sign-in';
  //   }, 500);
  // }



  const isPC = useMediaQuery({
    query: "(min-height:900px)"
  })


  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
        />


        <Typography variant='h5' align='center' ><span style={{textDecoration:'underline'}}>{i18n.t('AboutLC')}</span></Typography>
        <Divider className={classes.divider} />

        <Typography variant='body1' className={classes.about_label}>● {i18n.t('Operator')}: Steve</Typography>
        <Typography variant='body1' className={classes.about_label}>● {i18n.t('Addr')}: Seoul</Typography>
        <Typography variant='body1' className={classes.about_label}>● {i18n.t('Chargers')}: {selector_chgr_cnt}</Typography>
        <Typography variant='body1' className={classes.about_label}>● {i18n.t('Others')}: ...</Typography>


      {/* {isPC && (<div style={{position:"absolute", paddingRight:"10px", bottom:"10px", fontSize:"11px", fontWeight:"bold" }}>
          Copyright(c) 2021 Castpro Co., Ltd.
          All rights Reserved
          </div>
          )} */}
      </div>
    </Drawer>
  );
};


const useStyles = makeStyles(theme => ({
  drawer: {
    width: 220,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(1)
  },
  nav: {
    marginBottom: theme.spacing(2),
  },

  about_label: {
    paddingLeft: 12,
    height: 24,
  },
}));



Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  router: PropTypes.object
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
}

let mapStateToProps = (state) => {
  return {
    user: state.user,
    simuSettings: state.simuSettings
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);

